import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {adminAction, GetRolesAction} from '../action';

const tableId = 'roles';

function* execute(action: GetRolesAction): SagaIterator {
    const {tableDataRequest} = action.payload;
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getRolesPage,
        successAction: adminAction.getRolesSuccess,
        tableId,
    }));
}
/** Runs the admin saga that loads the roles list for the admin screen. */
export function* getRoles(): SagaIterator {
    yield takeLatestF('admin/GET_ROLES', execute);
}
